import React, { Children, useState} from "react";
import TreeView, {flattenTree} from "react-accessible-treeview";
import {GiHearts, GiSpades, GiClubs, GiDiamonds, GiCard2Diamonds, GiSpade, GiClusterBomb, GiSpadeSkull, GiDimetrodon} from "react-icons/gi";
import { IoMdArrowDropright } from "react-icons/io";
import cx from "classnames"
import styled from "styled-components";

const theme = {
    blue: {
      default: "#3f51b5",
      hover: "#283593",
    },
    pink: {
      default: "#e91e63",
      hover: "#ad1457",
    },
  };

const Button = styled.button`
  background-color: ${(props) => theme[props.theme].default};
  color: white;
  padding: 5px 15px;
  border-radius: 5px;
  outline: 0;
  border: 0; 
  text-transform: uppercase;
  margin: 10px 0px;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

Button.defaultProps = {
    theme: "blue",
  };


const system ={
    name: "System",
    children: 
    [
        //{name: "1" + GiClubs},
        //{name: "1" + GiDiamonds},
        //{name: "1" + GiHearts},
        //{name: "1" + GiSpades},
        {id: 1, name: ["1",<GiClubs/>," - ", "12+ bal, 15+ clubs or 18 any"],
            children: [
                {id: "1.1", name: ['1',<GiDiamonds />, " - ", "0-6 any, 5-11 minor(s) or 16+BAL"], 
                    children: [
                        {id: "1.1.1", name: ['1',<GiHearts />, " - ", "3+ hearts"], children:
                            [
                                {id: '1.1.1.1', name: ['1',<GiSpades />, " - ", "4+ spades"]},
                                {id: "1.1.1.2", name: ['1NT', " - ", "without 4M"]},
                                {id: "1.1.1.3", name: ['2',<GiClubs />, " - ", "5+ Clubs, 4-9 HCP"]},
                                {id: "1.1.1.4", name: ['2',<GiDiamonds />, " - ", "5+ Diamonds, 4-9 HCP"]},
                                {id: "1.1.1.5", name: ['2',<GiHearts />, " - ", "4+ Hearts, 4-6 HCP"]},
                                {id: "1.1.1.6", name: ['2',<GiSpades />, " - ", "(54)+ minors, 9-11HCP "]},
                                {id: "1.1.1.7", name: ['2NT', " - ", "16+HCP, balanced"]},
                                {id: "1.1.1.8", name: ['3',<GiClubs />, " - ", "6+ clubs, weak colour"]},
                                {id: "1.1.1.9", name: ['3',<GiDiamonds />, " - ", "6+ diamonds, weak colour"]},
                                {id: "1.1.1.10", name: ['3',<GiHearts />, " - ", "5+ hearts, inv. based on shape"]},
                                {id: "1.1.1.11", name: ['3',<GiSpades />, " - ", "13-15 HCP, play 3NT from your hand"]},
                            ]
                        },
                        {id: "1.1.2", name: ['1',<GiSpades />, " - ", "3+ spades"], children:
                            [
                                {id: "1.1.2.1", name: ['1NT', " - ", "without 4M"]},
                                {id: "1.1.2.2", name: ['2',<GiClubs />, " - ", "5+ Clubs, 4-9 HCP"]},
                                {id: "1.1.2.3", name: ['2',<GiDiamonds />, " - ", "5+ Diamonds, 4-9 HCP"]},
                                {id: "1.1.2.4", name: ['2',<GiHearts />, " - ", "5+ Hearts, 4-6 HCP"]},
                                {id: "1.1.2.5", name: ['2',<GiSpades />, " - ", "4+ spades, 4-6 HCP"]},
                                {id: "1.1.2.6", name: ['2NT', " - ", "16+HCP, balanced"]},
                                {id: "1.1.2.7", name: ['3',<GiClubs />, " - ", "6+ clubs, weak colour"]},
                                {id: "1.1.2.8", name: ['3',<GiDiamonds />, " - ", "6+ diamonds, weak colour"]},
                                {id: "1.1.2.9", name: ['3',<GiHearts />, " - ", "13-15 HCP, play 3NT from your hand"]},
                                {id: "1.1.2.10", name: ['3',<GiSpades />, " - ", "5+ spades, inv. based on shape"]},
                            ]
                        },
                        {id: "1.1.3", name: ['1NT', " - ", "18-20 Balanced"], children:
                            [{id: "1.1.3.1", name: "The same as after 1NT opening"}]
                        },
                        {id: "1.1.4", name: ['2',<GiClubs />, " - ", "5+ Clubs"], children:
                            [
                                {id: "1.1.4.1", name: "pass - nothing special, 2Clubs is non forcing" },
                                {id: "1.1.4.2", name: ["2", <GiDiamonds />, " - ", "GF, artificial" ] },
                                {id: "1.1.4.3", name: ["other", " - ", "natural, NF" ] },
                            ]
                        },
                        {id: "1.1.5", name: ['2',<GiDiamonds />," - ","GF" ], children:
                            [
                                {id: "1.1.5.1", name: ['2',<GiHearts />, " - ", "0-3 HCP"]},
                                {id: "1.1.5.2", name: ['!!!2',<GiSpades />, " - ", "transfer to 2NT, generally all hand without good 6+ colour"]},
                                {id: "1.1.5.3", name: ['2NT'," - ", ""]},
                                {id: "1.1.5.4", name: ['other'," - ", "nat, good 6+ colour"]},
                            ]
                        },

                        {id: "1.1.6", name: ['2',<GiHearts />, " - ", "6+ good hearts, sligtly under acol"]},
                        {id: "1.1.7", name: ['2',<GiSpades />, " - ", "6+ good spades, sligtly under acol"]},
                        {id: "1.1.8", name: ['2NT'," - ", "23-24HCP"]},
                        {id: "1.1.9", name: ['3',<GiClubs />," - ", "6+ clubs, almost GF"]},
                        {id: "1.1.10", name: ['3',<GiDiamonds />," - ", "6+diamonds, 18+HCP"]},
                        {id: "1.1.11", name: ['3',<GiHearts />," - ", "5hearts+, 5+m"]},
                        {id: "1.1.12", name: ['3',<GiSpades />," - ", "5spades+, 5+m"]},
                        {id: "1.1.13", name: ['3NT'," - ", ""]},
                        {id: "1.1.14", name: ['4',<GiClubs />," - ", "55 minors"]},
                        {id: "1.1.15", name: ['4',<GiDiamonds />," - ", "55 majors"]},
                    ]},
                {id: "1.2", name: ['1',<GiHearts />," - ", "4+ hearts, 7+HCP"], children:
                    [
                        {id: '1.2.1', name: ["1", ,<GiSpades />," - ", "12-14 4spades, 4spades nad 5+Clubs, 18+ 5+spades"], children:
                            [
                                {id: "1.2.1.1", name: ['1NT', " - ", "7-10(11) HCP"]},
                                {id: "1.2.1.2", name: ['2',<GiClubs />, " - ", "invitational two-way checkack"], children:
                                    [
                                        {id: "1.2.1.2.1", name: ['2',<GiDiamonds />, " - ", "automatic with 12-14"], children:
                                            [
                                                {id: "1.2.1.2.1.1", name: ['2',<GiHearts />, " - ", "5+ hearts"]},
                                                {id: "1.2.1.2.1.2", name: ['2',<GiSpades />, " - ", "4 spades"]},
                                                {id: "1.2.1.2.1.3", name: ['2NT', " - ", "Balanced hand"]},
                                                {id: "1.2.1.2.1.4", name: ['3',<GiClubs />, " - ", "5+ Clubs, unbalanced"]},
                                                {id: "1.2.1.2.1.5", name: ['3',<GiDiamonds />, " - ", "5+ Diamonds, unbalanced"]},
                                            ]
                                        },
                                        {id: "1.2.1.2.2", name: ['!!!2',<GiHearts />, " - ", "3 hearts, 5 spades, GF"]},
                                        {id: "1.2.1.2.3", name: ['2',<GiSpades />, " - ", "5+ spades, GF other than 5332"]},
                                        {id: "1.2.1.2.4", name: ['2NT', " - ", "5332 spades"]},
                                        {id: "1.2.1.2.5", name: ['!!!3',<GiClubs />, " - ", "5+ clubs"]},
                                        {id: "1.2.1.2.6", name: ['!!!3',<GiClubs />, " - ", "5+ diamonds, 5+spades, GF"]},        
                                    ]
                                },
                                {id: "1.2.1.3", name: ['2',<GiDiamonds />, " - ", "GF"]},
                                {id: "1.2.1.4", name: ['2',<GiHearts />, " - ", "5+ Hearts, NF"]},
                                {id: "1.2.1.5", name: ['2',<GiSpades />, " - ", "4+ spades, NF"]},
                                {id: "1.2.1.6", name: ['2NT', " - ", "6+ clubs, SO"]},
                                {id: "1.2.1.7", name: ['3',<GiClubs />, " - ", "5+ clubs, 5+ hearts, GF"]},
                                {id: "1.2.1.8", name: ['3',<GiDiamonds />, " - ", "5+ diamonds, 5+ hearts, GF"]},
                                {id: "1.2.1.9", name: ['3',<GiHearts />, " - ", "inv. based on shape"]},
                                {id: "1.2.1.10", name: ['3',<GiSpades />, " - ", "inv. based on shape"]},
                            ]
                        },
                        {id: '1.2.2', name: ["1NT"," - ", "12-14 wo 4M"], children:
                            [
                                {id: "1.2.2.1", name: ['2',<GiClubs />, " - ", "invitational two-way checkack"], children:
                                    [
                                        {id: "1.2.2.1.1", name: ['2',<GiDiamonds />, " - ", "automatic with 12-14"], children:
                                            [
                                                {id: "1.2.2.1.1.1", name: ['2',<GiHearts />, " - ", "5+ hearts"]},
                                                {id: "1.2.2.1.1.2", name: ['!!!2',<GiSpades />, " - ", "?"]},
                                                {id: "1.2.1.1.1.3", name: ['2NT', " - ", "Balanced hand"]},
                                                {id: "1.2.1.1.1.4", name: ['3',<GiClubs />, " - ", "5+ Clubs, unbalanced"]},
                                                {id: "1.2.1.1.1.5", name: ['3',<GiDiamonds />, " - ", "5+ Diamonds, unbalanced"]},
                                            ]
                                        },
                                    ]
                                },
                                {id: "1.2.2.2", name: ['2',<GiDiamonds />, " - ", "GF"]},
                                {id: "1.2.2.3", name: ['2',<GiHearts />, " - ", "5+ Hearts, NF"]},
                                {id: "1.2.2.4", name: ['2',<GiSpades />, " - ", "4+ spades,5+ Hearts, GF"]},
                                {id: "1.2.2.5", name: ['2NT', " - ", "6+ clubs, SO"]},
                                {id: "1.2.2.6", name: ['3',<GiClubs />, " - ", "5+ clubs, 5+ hearts, GF"]},
                                {id: "1.2.2.7", name: ['3',<GiDiamonds />, " - ", "5+ diamonds, 5+ hearts, GF"]},
                                {id: "1.2.2.8", name: ['3',<GiHearts />, " - ", "inv. based on shape"]},
                                {id: "1.2.2.9", name: ['3',<GiSpades />, " - ", "inv. based on shape"]},
                            ]
                        },
                        {id: '1.2.3', name: ["2",<GiClubs />," - ", "5+ clubs, 15+ HCP F1, if with 4spades then 18+HCP"], children:
                            [
                                {id: "1.2.3.1", name: ["2", <GiDiamonds />, " - ", "GF, artificial" ] },
                                {id: "1.2.3.2", name: ["other", " - ", "natural, NF" ] },
                            ]
                        },
                        {id: '1.2.4', name: ["2",<GiDiamonds />," - ", "odwrotka"], children:
                            [
                                {id: '1.2.4.1', name:["2",<GiHearts />," - ", "7-10(11) HCP, 4 hearts"], children:
                                    [
                                        {id: '1.2.4.1.1', name:["2NT"," - ", "ask about shape"]},
                                        {id: '1.2.4.1.2', name:["other"," - ", "natural, probably without heart support"]},
                                    ]
                                },
                                {id: '1.2.4.2', name:["2",<GiSpades />," - ", "(11)12+HCP, 4 hearts"], children:
                                    [
                                        {id: '1.2.4.2.1', name:["2NT"," - ", "ask about shape"]},
                                        {id: '1.2.4.2.2', name:["other"," - ", "natural, probably without heart support"]},
                                    ]
                                },
                                {id: '1.2.4.3', name:["2NT"," - ", "(11)12+HCP, 5 hearts"]},
                                {id: '1.2.4.4', name:["3",<GiClubs />," - ", "9-11 HCP, 5+ clubs, 4 hearts"]},
                                {id: '1.2.4.5', name:["3",<GiDiamonds />," - ", "9-11 HCP, 5+ diamonds, 4 hearts"]},
                                {id: '1.2.4.6', name:["3",<GiHearts />," - ", "5 hearts, unbalanced"]},
                                {id: '1.2.4.7', name:["3",<GiSpades />," - ", "5 hearts, balanced"]},
                                {id: '1.2.4.8', name:["3NT"," - ", "6 hearts, wo shortness"]},
                                {id: '1.2.4.9', name:["higher"," - ", "6 heart, shortness"]},
                            ]
                        },
                        {id: '1.2.5', name: ["2",<GiHearts />," - ", "4 hearts, 12-14 HCP"]},
                        {id: '1.2.6', name: ["2",<GiSpades />," - ", "4 spades, 5+ diamonds, 18+HCP"]},
                        {id: '1.2.7', name: ["2NT"," - ", "18+HCP, wo 3Hearts, may be 4 spades"]},
                        {id: '1.2.8', name: ["3",<GiClubs />," - ", "18+HCP, 4 clubs, 5+ diamonds, 18+HCP"]},
                        {id: '1.2.9', name: ["3",<GiDiamonds />," - ", "18+HCP, 6+ diamonds, 18+HCP"]},
                        {id: '1.2.10', name: ["3",<GiHearts />," - ", "(14)15-17+HCP, 5(4)+ clubs, 4hearts"]},
                        {id: '1.2.11', name: ["3NT"," - ", "gambling, but with stoppers"]},
                        {id: '1.2.12', name: ["other"," - ", "splinter"]},
                    ]
                 },
                {id: "1.3", name: ['1',<GiSpades />," - ", "4+ spades, 7+HCP"], children:
                    [
                        {id: '1.3.1', name: ["1NT"," - ", "12-14 wo 4M"], children:
                            [
                                {id: "1.3.1.1", name: ['2',<GiClubs />, " - ", "invitational two-way checkack"], children:
                                    [
                                        {id: "1.3.1.1.1", name: ['2',<GiDiamonds />, " - ", "automatic with 12-14"], children:
                                            [
                                                {id: "1.3.1.1.1.1", name: ['2',<GiHearts />, " - ", "4+ hearts, 5+spades"]},
                                                {id: "1.3.1.1.1.2", name: ['2',<GiSpades />, " - ", "5+spades"]},
                                                {id: "1.3.1.1.1.3", name: ['2NT', " - ", "Balanced hand"]},
                                                {id: "1.3.1.1.1.4", name: ['3',<GiClubs />, " - ", "5+ Clubs, unbalanced"]},
                                                {id: "1.3.1.1.1.5", name: ['3',<GiDiamonds />, " - ", "5+ Diamonds, unbalanced"]},
                                                {id: "1.3.1.1.1.6", name: ['3',<GiHearts />, " - ", "5+ Hearts, 5+spades"]},
                                                {id: "1.3.1.1.1.7", name: ['3',<GiSpades />, " - ", "6+ spades"]},
                                            ]
                                        },
                                    ]
                                },
                                {id: "1.3.1.2", name: ['2',<GiDiamonds />, " - ", "GF"]},
                                {id: "1.3.1.3", name: ['!!!2',<GiHearts />, " - ", "???"]},
                                {id: "1.3.1.4", name: ['2',<GiSpades />, " - ", "5+spades, end"]},
                                {id: "1.3.1.5", name: ['2NT', " - ", "6+ clubs, SO"]},
                                {id: "1.3.1.6", name: ['3',<GiClubs />, " - ", "5+ clubs, 5+ spades, GF"]},
                                {id: "1.3.1.7", name: ['3',<GiDiamonds />, " - ", "5+ diamonds, 5+ spades, GF"]},
                                {id: "1.3.1.8", name: ['3',<GiHearts />, " - ", "5+ hearts, 5+ spades, GF"]},
                                {id: "1.3.1.9", name: ['3',<GiSpades />, " - ", "inv. based on shape"]},
                            ]
                        },
                        {id: '1.3.2', name: ["2",<GiClubs />," - ", "5+ clubs, 15+ HCP F1"]},
                        {id: '1.3.3', name: ["2",<GiDiamonds />," - ", "odwrotka"], children:
                            [
                                {id: '1.3.3.1', name:["2",<GiHearts />," - ", "7-10(11) HCP, 4 spades"], children:
                                    [
                                        {id: '1.3.3.1.1', name:["2NT"," - ", "ask about shape"]},
                                        {id: '1.3.3.1.2', name:["other"," - ", "natural, probably without spades support"]},
                                    ]
                                },
                                {id: '1.3.3.2', name:["2",<GiSpades />," - ", "(11)12+HCP, 4 spades"], children:
                                    [
                                        {id: '1.3.3.2.1', name:["2NT"," - ", "ask about shape"]},
                                        {id: '1.3.3.2.2', name:["other"," - ", "natural, probably without spades support"]},
                                    ]
                                },
                                {id: '1.3.3.3', name:["2NT"," - ", "(11)12+HCP, 5 spades"]},
                                {id: '1.3.3.4', name:["3",<GiClubs />," - ", "9-11 HCP, 5+ clubs, 4 spades"]},
                                {id: '1.3.3.5', name:["3",<GiDiamonds />," - ", "9-11 HCP, 5+ diamonds, 4 spades"]},
                                {id: '1.3.3.6', name:["3",<GiHearts />," - ", "5 spades, unbalanced"]},
                                {id: '1.3.3.7', name:["3",<GiSpades />," - ", "5 spades, balanced"]},
                                {id: '1.3.3.8', name:["3NT"," - ", "6 spades, wo shortness"]},
                                {id: '1.3.3.9', name:["higher"," - ", "6 spades, shortness"]},
                            ]
                        },
                        {id: '1.3.4', name: ["2",<GiHearts />," - ", "5+ hearts, 18+"]},
                        {id: '1.3.5', name: ["2",<GiSpades />," - ", "4 spades, 12-14 HCP"]},
                        {id: '1.3.6', name: ["2NT"," - ", "18+HCP, wo 3 spades "]},
                        {id: '1.3.7', name: ["3",<GiClubs />," - ", "18+HCP, 4 clubs, 5+ diamonds, 18+HCP"]},
                        {id: '1.3.8', name: ["3",<GiDiamonds />," - ", "18+HCP, 6+ diamonds, 18+HCP"]},
                        {id: '1.3.9', name: ["3",<GiHearts />," - ", "5+ diamomnds, 4hearts"]},
                        {id: '1.3.10', name: ["3",<GiSpades />," - ", "(14)15-17+HCP, 5(4)+ clubs, 4 spades"]},
                        {id: '1.3.11', name: ["3NT"," - ", "gambling, but with stoppers"]},
                        {id: '1.3.12', name: ["other"," - ", "splinter"]},
                    ]
                  
                },
                {id: "1.4", name: ['1NT'," - ", "4-10 HCP, balanced wo 4M"], children:
                    [
                        {id: "1.4.1", name: ['2',<GiClubs />," - ", "5+ Clubs"]},
                        {id: "1.4.2", name: ['2',<GiDiamonds />," - ", "relay"], children:
                            [
                                {id: "1.4.2.1", name:["2",<GiHearts />," - ",'2',<GiSpades />,"3",<GiHearts />,"4",<GiDiamonds />,"4",<GiClubs />]},
                                {id: "1.4.2.2", name:['2',<GiSpades />," - ","3",<GiSpades />,"2",<GiHearts />,"4",<GiDiamonds />,"4",<GiClubs />]},
                                {id: "1.4.2.3", name:['2NT'," - ","3343"]},
                                {id: "1.4.2.4", name:['3',<GiClubs />," - ","5 clubs"], children:
                                    [
                                        {id: "1.4.2.4.1", name:['3',<GiDiamonds />," - ","ask about dubleton"], children:
                                            [
                                                {id: "1.4.2.4.1.1", name:['!!!3',<GiHearts />," - ","dubleton of heart"]},
                                                {id: "1.4.2.4.1.2", name:['!!!3',<GiSpades />," - ","dubleton of spades"]},
                                                {id: "1.4.2.4.1.3", name:["!!!3NT"," - ","dubleton of diamond"]}, 
                                            ]
                                        }
                                        
                                    ]
                                },
                                {id: "1.4.2.5", name:['3',<GiDiamonds />," - ","5 diamond, dubleton of clubs"]},
                                {id: "1.4.2.6", name:['3',<GiHearts />," - ","5 diamond, dubleton of hearts"]},
                                {id: "1.4.2.7", name:['3',<GiSpades />," - ","5 diamond, dubleton of spades"]},
                            ]
                         },
                        {id: "1.4.3", name: ['2',<GiHearts />," - 3",<GiDiamonds /> , "natural"] },
                        {id: "1.4.4", name: ['3',<GiHearts />," - 4",<GiDiamonds /> , "two colours, like after 1",<GiClubs />," -1",<GiDiamonds />] },
                    ]
                 },
                {id: "1.5", name: ['2',<GiClubs />," - ", "5+ Clubs, GF wo 4m"], children:
                    [
                        {id: "1.5.1", name:['2',<GiDiamonds />," - ","any 12-14HCP"]},
                        {id: "1.5.2", name:['2',<GiHearts />," - ","18+HCP, 5+hearts"]},
                        {id: "1.5.3", name:['2',<GiSpades />," - ","18+HCP, 5+spades"]},
                        {id: "1.5.4", name:['2NT'," - ","balanced, may be singleton in clubs"]},
                        {id: "1.5.5", name:['3',<GiClubs />," - ","5+clubs, 15+HCP"]},
                        {id: "1.5.6", name:['3',<GiDiamonds />," - ","6+diamond, 18+HCP"]},
                        {id: "1.5.7", name:['3',<GiHearts />," - ","Splinter"]},
                        {id: "1.5.8", name:['3',<GiSpades />," - ","Splinter"]},
                        {id: "1.5.9", name:['3NT'," - ","bad hand"]},
                    ]
                 },
                {id: "1.6", name: ['2',<GiDiamonds />," - ", "5+ Diamonds, GF wo 4m"], children:
                    [
                        {id: "1.6.1", name:['2',<GiHearts />," - ","3+hearts, may be only honours"]},
                        {id: "1.6.2", name:['2',<GiSpades />," - ","3+spades, may be only honours"]},
                        {id: "1.6.3", name:['2NT'," - ","balanced, good hand to NT"]},
                        {id: "1.6.4", name:['3',<GiClubs />," - ","5+clubs, 15+HCP"]},
                        {id: "1.6.5", name:['3',<GiDiamonds />," - ","4+diamond"]},
                        {id: "1.6.6", name:['3',<GiHearts />," - ","Splinter"]},
                        {id: "1.6.7", name:['3',<GiSpades />," - ","Splinter"]},
                        {id: "1.6.8", name:['3NT'," - ","bad hand"]},
                    ]
                 },
                {id: "1.7", name: ['2',<GiHearts />," - ", "6-9(10)HCP, 5+ spades, 4+ hearts"], children:
                    [
                        {id: "1.7.1", name: ["2",<GiSpades />, " - ","choose of contract"]},
                        {id: "1.7.2", name: ["2NT"," - ","relay"], children:
                            [
                                {id: "1.7.2.1", name: ["3",<GiClubs />, " - ","3 clubs"]},
                                {id: "1.7.2.2", name: ["3",<GiHearts />, " - ","3 diamond"]},
                                {id: "1.7.2.3", name: ["3",<GiSpades />, " - ","5 hearts"], children:
                                    [
                                    {id: "1.7.2.3.1", name: ["!!!3",<GiSpades />, " - ","we playing spades"]},
                                    {id: "1.7.2.3.2", name: ["4",<GiClubs />, " - ","we playing hearts"]},
                                    ]
                                },
                                {id: "1.7.2.4", name: ["3NT", " - ","5422"]}, 
                            ]
                        },
                        {id: "1.7.3", name: ["3",<GiClubs />, " - ","5+ clubs, GF"]},
                        {id: "1.7.4", name: ["3",<GiDiamonds />, " - ","6+ diamons, 18+HCP"]},
                        {id: "1.7.5", name: ["3",<GiHearts />, " - ","invitational with heart support"]},
                        {id: "1.7.6", name: ["3",<GiSpades />, " - ","invitational with spade support"]},
                        {id: "1.7.7", name: ["3NT", " - ","choose of contract"]}, 
                    ]
                },
                {id: "1.8", name: ['2',<GiSpades />," - ", "10-11(12)HCP, balanced wo 4M"] },
                {id: "1.9", name: ['2NT'," - ", "10-11(12)HCP, balanced wo 4M"] },
                {id: "1.10", name: ['3',<GiClubs />," - ", "invitational, 6+ good clubs"] },
                {id: "1.11", name: ['3',<GiDiamonds />," - ", "invitational, 6+ good diamonds"] },
                {id: "1.12", name: ['3',<GiHearts />," - ", "7+ good hearts, nothing else"] },
                {id: "1.13", name: ['3',<GiSpades />," - ", "7+ good spades, nothing else"] },
                {id: "1.14", name: ['3NT'," - ", "12-14(15) HCP, not a beatiful hand"] }
            ]
        },
        {id: 2, name: ["1",<GiDiamonds />," - ","5+ diamonds, 4 diamonds in any 4441 and with 5 clubs"], children:
            [
                {id: "2.1", name: ['1',<GiHearts />," - ", "4+ hearts, 6+HCP"], children: 
                    [
                        {id: "2.1.1", name: ['1',<GiSpades />," - ", "4+ spades"], children:
                            [
                                {id: "2.1.1.1", name: ['1NT', " - ", "7-10(11) HCP"]},
                                {id: "2.1.1.2", name: ['2',<GiClubs />, " - ", "invitational two-way checkack"], children:
                                    [
                                        {id: "2.1.1.2.1", name: ['2',<GiDiamonds />, " - ", "automatic with 12-14"], children:
                                            [
                                                {id: "2.1.1.2.1.1", name: ['2',<GiHearts />, " - ", "5 hearts"]},
                                                {id: "2.1.1.2.1.2", name: ['2',<GiSpades />, " - ", "4 spades"]},
                                                {id: "2.1.1.2.1.3", name: ['2NT', " - ", "Balanced hand"]},
                                                {id: "2.1.1.2.1.4", name: ['3',<GiClubs />, " - ", "5+ Clubs, unbalanced"]},
                                                {id: "2.1.1.2.1.5", name: ['3',<GiDiamonds />, " - ", "diamond support, unbalanced or 4+"]},
                                            ]
                                        },
                                        {id: "2.1.1.2.2", name: ['2',<GiHearts />, " - ","15-17 HCP, 3 hearts"], children:
                                            [
                                                {id: "2.1.1.2.2.1", name: ['3',<GiDiamonds />, " - ","choice of contract"]},
                                                {id: "2.1.1.2.2.2", name: ['3',<GiHearts />, " - ","invitational"]}
                                            ]
                                        },
                                        {id: "2.1.1.2.3", name: ['2',<GiSpades />, " - ", "16-17, 5 weak spades, invitational"]},
                                        {id: "2.1.1.2.4", name: ['2NT', " - ", "16-17, invitational"]},
                                        {id: "2.1.1.2.5", name: ['3',<GiClubs />, " - ", "4144, invitational"]},
                                        {id: "2.1.1.2.6", name: ['3',<GiDiamonds />, " - ", "6+ diamonds, invitational"]},        
                                    ]
                                },
                                {id: "2.1.1.3", name: ['2',<GiDiamonds />, " - ", "GF"], children:
                                    [
                                        {id: "2.1.1.3.1", name: ['2',<GiHearts />, " - ", "support in hearts, 12-14 HCP"]},
                                        {id: "2.1.1.3.2", name: ['2',<GiSpades />, " - ", "no club stoper"]},
                                        {id: "2.1.1.3.3", name: ['2NT', " - ", "club stoper"]},
                                        {id: "2.1.1.3.4", name: ['3',<GiClubs />, " - ", "4144"]},
                                        {id: "2.1.1.3.5", name: ['3',<GiDiamonds />, " - ", "6 diamonds"]},
                                        {id: "2.1.1.3.6", name: ['3',<GiHearts />, " - ", "support in heart, 15+HCP"]},
                                    ]
                                },
                                {id: "2.1.1.4", name: ['2',<GiHearts />, " - ", "5+ Hearts, NF"]},
                                {id: "2.1.1.5", name: ['2',<GiSpades />, " - ", "4+ spades, NF"]},
                                {id: "2.1.1.6", name: ['2NT', " - ", "6+ clubs, SO"]},
                                {id: "2.1.1.7", name: ['3',<GiClubs />, " - ", "5+ clubs, 5+ hearts, GF"]},
                                {id: "2.1.1.8", name: ['3',<GiDiamonds />, " - ", "diamonds support, inv. based on shape"]},
                                {id: "2.1.1.9", name: ['3',<GiHearts />, " - ", "inv. based on shape"]},
                                {id: "2.1.1.10", name: ['3',<GiSpades />, " - ", "inv. based on shape"]},
                            ]
                        },
                        {id: "2.1.2", name: ['1NT'," - ", "11-14 5 diam"], children:
                            [
                                {id: "2.1.2.1", name: ['2',<GiClubs />, " - ", "invitational two-way checkack"]},
                                {id: "2.1.2.2", name: ['2',<GiDiamonds />, " - ", "GF"]},
                                {id: "2.1.2.3", name: ['2NT', " - ", "6+ clubs, SO"]},
                            ]
                        },
                        {id: "2.1.3", name: ['2',<GiClubs />," - ", "11-17 5 diamonds 4 clubs or 4 diamonds 5 clubs"]},
                        {id: "2.1.4", name: ['2',<GiDiamonds />," - ", "11-14 HCP, 6+ diamonds"], children:
                            [
                                {id: "2.1.4.1", name: ['2',<GiHearts />," - ", "6+ heart, SO"]},
                                {id: "2.1.4.2", name: ['2',<GiSpades />," - ", "GF, values in spades"]},
                                {id: "2.1.4.3", name: ['!!!2NT'," - ", "GF, relay"]},
                                {id: "2.1.4.4", name: ['3',<GiClubs />," - ", "GF, values in clubs"]},
                                {id: "2.1.4.5", name: ['3',<GiDiamonds />," - ", "invitational"]},
                            ]
                        },
                        {id: "2.1.5", name: ['2',<GiHearts />," - ", "11-14 HCP,  4 hearts"], children:
                            [
                                {id: "2.1.5.1", name: ['2',<GiSpades />," - ", "invitational, need support in spades"]},
                                {id: "2.1.5.2", name: ['2NT'," - ", "GF, relay"], children:
                                    [
                                        {id: "2.1.5.2.1", name: ['3',<GiClubs />," - ", "3+ clubs"]},
                                        {id: "2.1.5.2.2", name: ['3',<GiDiamonds />," - ", "6+ Diamonds"]},
                                        {id: "2.1.5.2.3", name: ['3',<GiHearts />," - ", "2452, good hand"]},
                                        {id: "2.1.5.2.4", name: ['3',<GiSpades />," - ", "3+ spades"], children:
                                            [
                                                {id: "2.1.5.2.4.1", name: ['3NT',<GiSpades />," - ", "waiting, show cuebid or revoke"]},
                                            ]
                                        },
                                        {id: "2.1.5.2.5", name: ['3NT'," - ", "2452, good hand"]}
                                    ]
                                },
                                {id: "2.1.5.3", name: ['3',<GiClubs />," - ", "invitational, need support in clubs"]},
                                {id: "2.1.5.4", name: ['3',<GiDiamonds />," - ", "invitational, support in diamonds"]},
                                {id: "2.1.5.5", name: ['3',<GiHearts />," - ", "NF, good shape, preemptive"]},
                                {id: "2.1.5.6", name: ['3NT'," - ", "sugestion of contract"]},
                                {id: "2.1.5.7", name: ['other'," - ", "splinter, (including splinter in diamonds!)"]},
                            ]
                        },
                        {id: "2.1.6", name: ['2',<GiSpades />," - ", "15-17 HCP, 6 diamonds, 3 hearts"], children:
                            [
                                {id: "2.1.6.1", name: ['2NT'," - ", "relay, GF"], children:
                                    [
                                        {id: "2.1.6.1.1", name: ['3',<GiClubs />,' - ',"shortness in clubs"]},
                                        {id: "2.1.6.1.2", name: ['3',<GiDiamonds />,' - ',"7 diamonds, no revoke"]},
                                        {id: "2.1.6.1.3", name: ['3',<GiHearts />,' - ',"shortness in spades"]},
                                        {id: "2.1.6.1.4", name: ['3',<GiSpades />,' - ',"2362, good hand"]},
                                        {id: "2.1.6.1.5", name: ['3NT',' - ',"2362, honours in short colours"]},
                                    ]
                                },
                                {id: "2.1.6.2", name: ['3',<GiClubs />," - ", "GF, values in clubs, suggest weak spades"]},
                                {id: "2.1.6.3", name: ['3',<GiDiamonds />," - ", "NF"]},
                                {id: "2.1.6.4", name: ['3',<GiHearts />," - ", "NF"]},
                                {id: "2.1.6.5", name: ['3',<GiSpades />," - ", "GF, values in spades, weak clubs"]},
                                {id: "2.1.6.6", name: ['3NT'," - ", "choose of contract"]},
                            ]
                        },
                        {id: "2.1.7", name: ['2NT'," - ", "15-17 HCP, 6 diamonds, good hand to NT"]},
                        {id: "2.1.8", name: ['3',<GiClubs />," - ", "15-17 HCP, 5 diamonds 5 clubs"]},
                        {id: "2.1.9", name: ['3',<GiDiamonds />," - ", "15-17 HCP,6 diamonds"]},
                        {id: "2.1.10", name: ['3',<GiHearts />," - ", "(14)15-17 HCP,4 hearts"]},
                        {id: "2.1.11", name: ['3',<GiSpades />," - ", " shortness, (14)15-17 HCP, 4 hearts, very good hand"]},
                        {id: "2.1.12", name: ['4',<GiClubs />," - ", " shortness, (14)15-17 HCP, 4 hearts, very good hand"]},
                        {id: "2.1.13", name: ['4',<GiHearts />," - ", " 6+ diam,  4 hearts, weaker than splinter"]}, 
                    ]
                },
                {id: "2.2", name: ['1',<GiSpades />," - ", "4+ spades, 6+HCP"], children: 
                    [
                        {id: "2.2.1", name: ['1NT'," - ", "11-14 4+ diam (may be 4441) "], children:
                            [
                                {id: "2.2.1.1", name: ['2',<GiClubs />, " - ", "invitational two-way checkack"]},
                                {id: "2.2.1.2", name: ['2',<GiDiamonds />, " - ", "GF"], children:
                                    [
                                        {id: "2.2.1.2.1", name: ['2',<GiHearts />, " - ","4 hearts, may be 3 spades"]},
                                        {id: "2.2.1.2.2", name: ['2',<GiSpades />, " - ","3 spades, no  hearts"]},
                                        {id: "2.2.1.2.3", name: ['2NT'," - ","other hands"]},
                                        {id: "2.2.1.2.4", name: ['3',<GiClubs />," - ","4 clubs, honours in short colors"]}, 
                                    ]
                                },
                            ]
                        },
                        {id: "2.2.2", name: ['2',<GiClubs />," - ", "11-17 5 diamonds 4 clubs or 4 diamonds 5 clubs"]},
                        {id: "2.2.3", name: ['2',<GiDiamonds />," - ", "11-14 6+ diamonds"], children:
                            [
                                {id: "2.2.3.1", name: ['2',<GiHearts />," - ", "bid 2",<GiSpade />,"SO with spades or any GF"]},
                                {id: "2.2.3.2", name: ['2',<GiSpades />," - ", "Invitational with 6 spades"]},
                                {id: "2.2.3.3", name: ['3',<GiSpades />," - ", "Invitational based on shape"]},
                            ]
                        },
                        {id: "2.2.4", name: ['2',<GiHearts />," - ", "15-17 HCP, 4 hearts or 6 diamonds and 3 spades"], children:
                            [
                                {id: "2.2.4.1", name: ['2',<GiSpades />," - ", "6+ spades, NF"]},
                                {id: "2.2.4.2", name: ['2NT'," - ", "relay"], children:
                                    [
                                        {id: "2.2.4.2.1", name: ['3',<GiClubs />," - ", "1453"]},
                                        {id: "2.2.4.2.2", name: ['3',<GiDiamonds />," - ", "6 diamonds, 4 hearts"]},
                                        {id: "2.2.4.2.3", name: ['3',<GiHearts />," - ", "6 diamonds, 3 spades"]},
                                        {id: "2.2.4.2.4", name: ['!!!3',<GiSpades />," - ", "3451 - jak uzgodnić kiery?"]},
                                        {id: "2.2.4.2.5", name: ['3NT'," - ", "2452"]},
                                    ]
                                },
                                {id: "2.2.4.3", name: ['3',<GiClubs />," - ", "values in clubs, suggest weak hearts"]},
                                {id: "2.2.4.4", name: ['3',<GiDiamonds />," - ", "NF"]},
                                {id: "2.2.4.5", name: ['!!!3',<GiHearts />," - ", "??"]},
                                {id: "2.2.4.6", name: ['!!!3',<GiSpades />," - ", "6+ good spades, we playing spades"]},
                                {id: "2.2.4.7", name: ['3NT'," - ", "choose of contract"]},
                            ]
                        },
                        {id: "2.2.5", name: ['2',<GiSpades />," - ", "12-14 4 spades"]},
                        {id: "2.2.6", name: ['2NT'," - ", "15-17 6 diamonds, good hand to NT"]},
                        {id: "2.2.7", name: ['3',<GiClubs />," - ", "15-17 5 diamonds 5 clubs"]},
                        {id: "2.2.8", name: ['3',<GiDiamonds />," - ", "15-17 6 diamonds"]},
                        {id: "2.2.9", name: ['3',<GiHearts />," - ", "shortness, (14)15-17 4 spades, very good hand"]},
                        {id: "2.2.10", name: ['3',<GiSpades />," - ", "(14)15-17 4 spades"]},
                        {id: "2.2.11", name: ['4',<GiClubs />," - ", " shortness, (14)15-17 4 spades, very good hand"]},
                        {id: "2.2.12", name: ['4',<GiHearts />," - ", "revoke in hearts, 6+ diam,  4 spades"]},
                        {id: "2.2.13", name: ['4',<GiSpades />," - ", "6+ diam,  4 spades, weaker than splinter"]},  
                    ]
                },
                {id: "2.3", name: ['1NT'," - ", " 7-10(11)HCP, wo 4M"], children: 
                    [
                        {id: "2.3.1", name: ['2',<GiClubs />," - ", "11-17 HCP 5 diamonds 4 clubs or 4 diamonds 5 clubs"]},
                        {id: "2.3.2", name: ['2',<GiDiamonds />," - ", "11-14 HCP 6+ diamonds"]},
                        {id: "2.3.3", name: ['2',<GiHearts />," - ", "15-17 HCP, 4(3+) hearts"]},
                        {id: "2.3.4", name: ['2',<GiSpades />," - ", "15-17 HCP, 4(3+) spades"]},
                        {id: "2.3.5", name: ['2NT'," - ", "15-17 HCP, good hand to NT"]},
                        {id: "2.3.6", name: ['3',<GiClubs />," - ", "15-17 HCP, 5 diamonds 5 clubs"]},
                        {id: "2.3.7", name: ['3',<GiDiamonds />," - ", "15-17 HCP,6 diamonds"]},
                        {id: "2.3.8", name: ['3',<GiHearts />," - ", "(14)15-17 HCP, 5 weak hearts"]},
                        {id: "2.3.9", name: ['3',<GiSpades />," - ", " (14)15-17 HCP, 5 weak spades"]},
                    ]
                },
                {id: "2.4", name: ['2',<GiClubs />," - ", "GF, 5+ clubs, wo 4M"], children: 
                    [
                        {id: "2.4.1", name: ['!!2',<GiDiamonds />," - ", "any 11-14, excluding 4 card support in clubs and shortness"]},
                        {id: "2.4.2", name: ['2',<GiHearts />," - ", "15-17 4 hearts"]},
                        {id: "2.4.3", name: ['2',<GiSpades />," - ", "15-17 4 spades"]},
                        {id: "2.4.4", name: ['!!!2NT'," - ", "15-17 HCP, 4441"]},
                        {id: "2.4.5", name: ['!!!3',<GiClubs />," - ", "15-17 HCP, 4+ clubs"]},
                        {id: "2.4.6", name: ['3',<GiDiamonds />," - ", "15-17 HCP, 6+ diamonds"]},
                        {id: "2.4.7", name: ['3',<GiHearts />," - ", "12-14, 4+ clubs, shortness in hearts"]},
                        {id: "2.4.8", name: ['3',<GiSpades />," - ", "12-14, 4+ clubs, shortness in spades"]},  
                    ]
                },
                {id: "2.5", name: ['2',<GiDiamonds />," - ", "10+HCP, 4+ diamonds, wo 4M"], children:
                    [
                        {id: "2.5.1", name: ["2",<GiHearts />," - ","GF, values in hearts" ]},
                        {id: "2.5.2", name: ["2",<GiSpades />," - ","GF, values in spades" ]},
                        {id: "2.5.3", name: ["2NT"," - ","GF, good hand to NT" ]},
                        {id: "2.5.4", name: ["3",<GiClubs />," - ","GF, 4+clubs" ]},
                        {id: "2.5.5", name: ["3",<GiDiamonds />," - ","11-12(13), NF" ]},
                        {id: "2.5.6", name: ["3NT"," - ","choose of contract" ]},
                        {id: "2.5.7", name: ["other"," - ","shortness, good hand" ]},
                    ]
                },
                {id: "2.6", name: ['2',<GiHearts />," - ", "5-9 HCP, 5+ spades, 4+ hearts"], children:
                    [
                        {id: "2.6.1", name: ["2",<GiSpades />, " - ","choose of contract"]},
                        {id: "2.6.2", name: ["2NT"," - ","relay"], children:
                            [
                                {id: "2.6.2.1", name: ["3",<GiClubs />, " - ","3 clubs"]},
                                {id: "2.6.2.2", name: ["3",<GiHearts />, " - ","3 diamond"]},
                                {id: "2.6.2.3", name: ["3",<GiSpades />, " - ","5 hearts"], children:
                                    [
                                    {id: "2.6.2.3.1", name: ["!!!3",<GiSpades />, " - ","we playing spades"]},
                                    {id: "2.6.2.3.2", name: ["4",<GiClubs />, " - ","we playing hearts"]},
                                    ]
                                },
                                {id: "2.6.2.4", name: ["3NT", " - ","5422"]}, 
                            ]
                        },
                        {id: "2.6.3", name: ["3",<GiClubs />, " - ","5+ clubs, NF"]},
                        {id: "2.6.4", name: ["3",<GiDiamonds />, " - ","6+ diamons, NF"]},
                        {id: "2.6.5", name: ["3",<GiHearts />, " - ","invitational with heart support"]},
                        {id: "2.6.6", name: ["3",<GiSpades />, " - ","invitational with spade support"]},
                        {id: "2.6.7", name: ["3NT", " - ","choose of contract"]},
                        {id: "2.6.8", name: ["4",<GiClubs />, " - ","shortness"]},
                        {id: "2.6.9", name: ["4",<GiDiamonds />, " - ","GF, we playing diamonds"]},
                        {id: "2.6.10", name: ["5",<GiClubs />, " - ","GF, big hand with mm"]}, 
                    ]
                },
                {id: "2.7", name: ['2',<GiSpades />," - ", "9-11 HCP, 6+ clubs"], children:
                    [
                        {id: "2.7.1", name: ['2NT'," - ", "GF, relay"], children:
                            [
                                {id: "2.7.1.1", name: ['3',<GiClubs />," - ", "no shortness, worse hand"]},
                                {id: "2.7.1.2", name: ['3',<GiDiamonds />," - ", "shortness"]},
                                {id: "2.7.1.3", name: ['3',<GiHearts />," - ", "shortness"]},
                                {id: "2.7.1.4", name: ['3',<GiSpades />," - ", "shortness"]},
                                {id: "2.7.1.5", name: ['3NT'," - ", "no shortness, better hand"]},
                            ]
                        }
                    ]
                },
                {id: "2.8", name: ['2NT'," - ", "10-11(12) HCP, balanced wo 4M"]},
                {id: "2.9", name: ['3',<GiClubs />," - ", "0-5 with 4+ diamonds or any splinter"]},
                {id: "2.10", name: ['3',<GiDiamonds />," - ", "6-9 with 4+ diam"]},
                {id: "2.11", name: ['3',<GiHearts />," - ", "9-12 with 4+ diam, shortness, forced only to 4",<GiDiamonds />]},
                {id: "2.12", name: ['3',<GiDiamonds />," - ", "9-12 with 4+ diam, shortness, forced only to 4",<GiDiamonds />]},
                {id: "2.13", name: ['3NT'," - ", "9-12 with 4+ diam, shortness, forced only to 4",<GiDiamonds />]},
            ]
        },
        {id: 3, name: ["1",<GiHearts />,' - ',"5+ hearts, 11-17"], children:
            [
                {id: "3.1", name: ["1",<GiSpades />,' - ',"4+ spades, 7+ HCP"], children:
                    [
                        {id: "3.1.1", name: ["1NT",' - ',"12-14 HCP, 5332 or similar"]},
                        {id: "3.1.2", name: ["2",<GiClubs />,' - ',"11-17 HCP, 4+ clubs"]},
                        {id: "3.1.3", name: ["2",<GiDiamonds />,' - ',"11-17 HCP, 4+ diamonds"]},
                        {id: "3.1.4", name: ["2",<GiHearts />,' - ',"11-14 HCP, 6+ hearts"], children:
                            [
                                {id: "3.1.4.1", name: ["2NT",' - ',"GF relay"], children:
                                    [
                                        {id: "3.1.4.1.1", name: ["!!!3",<GiClubs />,' - ',"shortness"]},
                                        {id: "3.1.4.1.2", name: ["!!!3",<GiDiamonds />,' - ',"shortness"]},
                                        {id: "3.1.4.1.3", name: ["!!!3",<GiHearts />,' - ',"no shortness, 3 spades"]},
                                        {id: "3.1.4.1.4", name: ["!!!3",<GiSpades />,' - ',"no shortness, no 3 spades, better hand"]},
                                        {id: "3.1.4.1.5", name: ["!!!3NT",' - ',"no shortness, no 3 spades, minimum hand"]},
                                    ]
                                },
                            ]
                        },
                        {id: "3.1.5", name: ["2",<GiSpades />,' - ',"11-14 HCP, 4 spades"]},
                        {id: "3.1.6", name: ["2NT",' - ',"15-17 HCP, around 2533"]},
                        {id: "3.1.7", name: ["3",<GiClubs />,' - ',"15-17 HCP, 5+ clubs"]},
                        {id: "3.1.8", name: ["3",<GiDiamonds />,' - ',"15-17 HCP, 5+ diamonds"]},
                        {id: "3.1.9", name: ["3",<GiHearts />,' - ',"15-17 HCP, 6+ hearts"]},
                        {id: "3.1.10", name: ["3",<GiSpades />,' - ',"15-17 HCP, 4 spades"]},
                    ]
                },
                {id: "3.2", name: ["1NT",' - '," 7-11 HCP, no support in heart, no 4 spades"], children:
                    [
                        {id: "3.2.1", name: ["2",<GiClubs />,' - ',"11-17 HCP, 4+ clubs"]},
                        {id: "3.2.2", name: ["2",<GiDiamonds />,' - ',"11-17 HCP, 4+ diamonds"]},
                        {id: "3.2.3", name: ["2",<GiHearts />,' - ',"11-14 HCP, 6+ hearts"]},
                        {id: "3.2.4", name: ["2",<GiSpades />,' - ',"15-17 HCP, 4 spades"]},
                        {id: "3.2.5", name: ["2NT",' - ',"15-17 HCP, around 2533"]},
                        {id: "3.2.6", name: ["3",<GiClubs />,' - ',"15-17 HCP, 5+ clubs"]},
                        {id: "3.2.7", name: ["3",<GiDiamonds />,' - ',"15-17 HCP, 5+ diamonds"]},
                        {id: "3.2.8", name: ["3",<GiHearts />,' - ',"15-17 HCP, 6+ hearts"]},
                    ]
                },
                {id: "3.3", name: ["2",<GiClubs />," - ","GF, clubs or balanced or 4+ support in hearts"], children:
                    [
                        {id: "3.3.1", name: ["2",<GiDiamonds />," - ","4+ diamonds"], children:
                            [
                                {id: "3.3.1.1", name: ["2",<GiHearts />," - ","support in hearts, relay about distribution"]},
                                {id: "3.3.1.2", name: ["2",<GiSpades />," - ","4th colur"]},
                                {id: "3.3.1.3", name: ["2NT"," - ","relay about distribution"]},
                                {id: "3.3.1.4", name: ["3",<GiClubs />," - ","6+ clubs, better hand"]},
                                {id: "3.3.1.5", name: ["3",<GiDiamonds />," - ","4+ diamond, better hand, show shortness with better hand"], children:
                                    [
                                        {id: "3.3.1.5.1", name: ["3 - to be continued"]},
                                    ]
                                },
                                {id: "3.3.1.6", name: ["3",<GiHearts />," - ","heart support, better hand, show shortness with better hand"], children:
                                    [
                                        {id: "3.3.1.6.1", name: ["3",<GiSpades />," - ","spade shortness"]},
                                        {id: "3.3.1.6.2", name: ["3NT"," - ","no shortness, better hand"]},
                                        {id: "3.3.1.6.3", name: ["4",<GiClubs />," - ","club shortness"]},
                                        {id: "3.3.1.6.4", name: ["4",<GiDiamonds />," - ","both club and spade shortness"]},
                                        {id: "3.3.1.6.5", name: ["4",<GiHearts />," - ","minimum hand"]}, 
                                    ]
                                },
                            ]
                        },
                        {id: "3.3.2", name: ["2",<GiHearts />," - ","12-14 HCP, various hand"]},
                        {id: "3.3.3", name: ["2",<GiSpades />," - ","15-17 HCP, 4 spades"]},
                        {id: "3.3.4", name: ["2NT"," - ","15-17 HCP, balanced or weak 6 hearts"]},
                        {id: "3.3.5", name: ["3",<GiClubs />," - ","15-17 HCP, 4+ clubs"]},
                        {id: "3.3.6", name: ["3",<GiDiamonds />," - ","15-17 HCP, 5+ diamonds"]},
                        {id: "3.3.7", name: ["3",<GiHearts />," - ","15-17 HCP, 6+ hearts"]},
                        {id: "3.3.8", name: ["3",<GiSpades />," - ","15-17 HCP, shortness, 4+ clubs"]},
                        {id: "3.3.9", name: ["4",<GiClubs />," - ","15-17 HCP, shortness, 4+ clubs"]} 
                    ]
                },
                {id: "3.4", name: ["2",<GiDiamonds />," - ","GF, 5+ diamonds"], children:
                    [
                        {id: "3.4.1", name: ["2",<GiHearts />," - ","all hands with 12-14 HCP"], children:
                            [
                                {id: "3.4.1.1", name: ["2",<GiSpades />," - ","values in spades"]},
                                {id: "3.4.1.2", name: ["2NT"," - ","relay about distribution"]},
                                {id: "3.4.1.3", name: ["3",<GiClubs />," - ","values in clubs"]},
                                {id: "3.4.1.4", name: ["3",<GiDiamonds />," - ","6+ diamons, better hand"]},
                                {id: "3.4.1.5", name: ["3",<GiHearts />," - ","heart support, better hand,(???) show shortness with better hand"], children:
                                    [
                                        {id: "3.4.1.5.1", name: ["??3",<GiSpades />," - ","spade shortness"]},
                                        {id: "3.4.1.5.2", name: ["3NT"," - ","no shortness, better hand"]},
                                        {id: "3.4.1.5.3", name: ["??4",<GiClubs />," - ","club shortness"]},
                                        {id: "3.4.1.5.4", name: ["4",<GiDiamonds />," - ","diamond shortness"]},
                                        {id: "3.4.1.5.5", name: ["4",<GiHearts />," - ","minimum hand"]}, 
                                    ]
                                },
                            ]
                        },
                        {id: "3.4.2", name: ["2",<GiSpades />," - ","15-17 HCP, 4 spades"]},
                        {id: "3.4.3", name: ["2NT"," - ","15-17 HCP, balanced or weak 6 hearts"]},
                        {id: "3.4.4", name: ["3",<GiClubs />," - ","15-17 HCP, 4+ clubs"]},
                        {id: "3.4.5", name: ["3",<GiDiamonds />," - ","15-17 HCP, 4+ diamonds"]},
                        {id: "3.4.6", name: ["3",<GiHearts />," - ","15-17 HCP, 6+ good hearts"]},
                        {id: "3.4.7", name: ["3",<GiSpades />," - ","15-17 HCP, shortness, 4+ diamond"]},
                        {id: "3.4.8", name: ["4",<GiClubs />," - ","15-17 HCP, shortness, 4+ diamonds"]} 
                    ]
                },
                {id: "3.5", name: ["2",<GiHearts />," - ","(5)6-9(10), 3+ hearts"]},
                {id: "3.6", name: ["2",<GiSpades />," - ","5-9 HCP, 6+ spades"]},
                {id: "3.7", name: ["2NT"," - ","invitational with heart support"]},
                {id: "3.8", name: ["3",<GiClubs />," - ","9-11 HCP, 6+ good clubs"]},
                {id: "3.9", name: ["3",<GiDiamonds />," - ","9-11 HCP, 6+ good diamonds"]},
                {id: "3.10", name: ["3",<GiHearts />," - "," 4+ hearts preemptive"]},
                {id: "3.11", name: ["3",<GiSpades />," - ","splinter"]},
                {id: "3.12", name: ["3NT"," - ","diamond splinter"]},
                {id: "3.13", name: ["4",<GiClubs />," - ","splinter"]},
                {id: "3.14", name: ["4",<GiDiamonds />," - ","12-14 with heart support, no slam aspiration"]},
            ]
        },
        {id: 4, name: ["1",<GiSpades />," - ", "5+ spade, 11-17"], children:
            [
                {id: "4.1", name: ["1NT"," - ", "6-11 without spade support"], children:
                    [
                        {id: "4.1.1", name: ["2",<GiClubs />,' - ',"11-17 HCP, 4+ clubs"]},
                        {id: "4.1.2", name: ["2",<GiDiamonds />,' - ',"11-17 HCP, 4+ diamonds"]},
                        {id: "4.1.3", name: ["2",<GiHearts />,' - ',"11-17 HCP, 4+ hearts"]},
                        {id: "4.1.4", name: ["2",<GiSpades />,' - ',"11-14 HCP, 6 spades"]},
                        {id: "4.1.5", name: ["2NT",' - ',"15-17 HCP, around 2533"]},
                        {id: "4.1.6", name: ["3",<GiClubs />,' - ',"15-17 HCP, 5+ clubs"]},
                        {id: "4.1.7", name: ["3",<GiDiamonds />,' - ',"15-17 HCP, 5+ diamonds"]},
                        {id: "4.1.8", name: ["3",<GiHearts />,' - ',"15-17 HCP, 6+ hearts"]},
                    
                    ]
                },
                {id: "4.2", name: ["2",<GiClubs />," - ", "GF, clubs or balanced or 4 card support"], children:
                    [
                        {id: "4.2.1", name: ["2",<GiDiamonds />," - ","4+ diamonds"], children:
                            [
                                {id: "4.2.1.1", name: ["2",<GiHearts />," - ","4th colour"]},
                                {id: "4.2.1.2", name: ["2",<GiSpades />," - ","support in spades, relay about distribution"]},
                                {id: "4.2.1.3", name: ["2NT"," - ","relay about distribution"]},
                                {id: "4.2.1.4", name: ["3",<GiClubs />," - ","6+ clubs, better hand"]},
                                {id: "4.2.1.5", name: ["3",<GiDiamonds />," - ","4+ diamond, better hand, show shortness with better hand"], children:
                                    [
                                        {id: "4.2.1.5.1", name: ["3 - to be continued"]},
                                    ]
                                },
                                {id: "4.2.1.7", name: ["3",<GiHearts />," - ","shortness, good diamond support"]},
                                {id: "4.2.1.6", name: ["3",<GiSpades />," - ","spade support, better hand, show shortness with better hand"], children:
                                    [
                                        {id: "4.2.1.6.1", name: ["3NT"," - ","no shortness, better hand"]},
                                        {id: "4.2.1.6.2", name: ["4",<GiClubs />," - ","club shortness"]},
                                        {id: "4.2.1.6.3", name: ["4",<GiDiamonds />," - ","both club and heart shortness"]},
                                        {id: "4.2.1.6.4", name: ["4",<GiHearts />," - ","heart support"]},
                                        {id: "4.2.1.6.5", name: ["5",<GiSpades />," - ","minimum, no shortness"]},  
                                    ]
                                },
                            ]
                        },
                        {id: "4.2.2", name: ["2",<GiHearts />," - ","12-17 HCP, 4+ hearts"]},
                        {id: "4.2.3", name: ["2",<GiSpades />," - ","12-14 HCP, various hand"]},
                        {id: "4.2.4", name: ["2NT"," - ","15-17 HCP, balanced or weak 6 spades"]},
                        {id: "4.2.5", name: ["3",<GiClubs />," - ","15-17 HCP, 4+ clubs"]},
                        {id: "4.2.6", name: ["3",<GiDiamonds />," - ","15-17 HCP, 5+ diamonds"]},
                        {id: "4.2.7", name: ["3",<GiHearts />," - ","15-17 HCP, 5+ hearts"], children:
                            [
                                {id: "4.2.7.1", name: ["3",<GiSpades />," - ","set spades as trump"]},
                                {id: "4.2.7.2", name: ["3NT"," - ","choose off contract"]},
                                {id: "4.2.7.3", name: ["4 other"," - ","cuebid - set heart as trump"]},
                            ]
                        },
                        {id: "4.2.8", name: ["3",<GiSpades />," - ","15-17 HCP, 6+ good spades"]},
                        {id: "4.2.9", name: ["4",<GiClubs />," - ","15-17 HCP, shortness, 4+ clubs"]} 
                    ]
                },
                {id: "4.3", name: ["2",<GiDiamonds />," - ", "GF, 5+ good diamonds"], children:
                    [
                        {id: "4.3.0", name: ["2",<GiHearts />," - ","12-17 HCP, 4+ hearts"]},
                        {id: "4.3.1", name: ["2",<GiSpades />," - ","12-14 HCP, various hand"]},
                        {id: "4.3.2", name: ["2NT"," - ","15-17 HCP, balanced or weak 6 spades"]},
                        {id: "4.3.3", name: ["3",<GiClubs />," - ","15-17 HCP, 4+ clubs"]},
                        {id: "4.3.4", name: ["3",<GiDiamonds />," - ","15-17 HCP, diamond support"]},
                        {id: "4.3.5", name: ["3",<GiHearts />," - ","15-17 HCP, 5+ hearts"], children:
                            [
                                {id: "4.3.5.1", name: ["3",<GiSpades />," - ","set spades as trump"]},
                                {id: "4.3.5.2", name: ["3NT"," - ","choose off contract"]},
                                {id: "4.3.5.3", name: ["4 other"," - ","cuebid - set heart as trump"]},
                            ]
                        },
                    ]
                },
                {id: "4.4", name: ["2",<GiHearts />," - ", "GF, 5+ hearts"], children:
                    [
                        {id: "4.4.1", name: ["2",<GiSpades />," - ","12-14 HCP, various hand"]},
                        {id: "4.4.2", name: ["2NT"," - ","15-17 HCP, balanced or weak 6 spades"]},
                        {id: "4.4.3", name: ["3",<GiClubs />," - ","15-17 HCP, 4+ clubs"]},
                        {id: "4.4.4", name: ["3",<GiDiamonds />," - ","15-17 HCP, 4+ diamonds "]},
                        {id: "4.4.5", name: ["3",<GiHearts />," - ","15-17 HCP, heart support"]},
                    ]
                },
                {id: "4.5", name: ["2",<GiSpades />," - ", "(5)6-9(10), 3+ spades"]},
                {id: "4.6", name: ["2NT",<GiSpades />," - ", "invitational with spade support"]},
            ]
        },
        {id: 5, name: ['1NT'," - ","(14)15-16(17), balanced, may be 5 mayor, 6 minor"], children:
            [
                {id: "5.1", name:["2",<GiClubs />," - ","stayman"], children:
                    [
                        {id: "5.1.1", name:["2",<GiDiamonds />," - ","no 4M"], children:
                            [
                                {id: "5.1.1.1", name:["2",<GiHearts />," - ","both 4M, weak"]},
                                {id: "5.1.1.2", name:["2",<GiSpades />," - ","5 spades, 4 hearts, invitational"]},
                                {id: "5.1.1.3", name:["2NT"," - ","invitational"]},
                                {id: "5.1.1.4", name:["3",<GiClubs />," - ","GF, 5+ clubs, slam interest or very unbalanced hand"]},
                                {id: "5.1.1.5", name:["3",<GiDiamonds />," - ","GF, 5+ diamond, slam interest or very unbalanced hand"]},
                                {id: "5.1.1.6", name:["3",<GiHearts />," - ","GF, 5 spades, 4 hearts"]},
                                {id: "5.1.1.7", name:["3",<GiSpades />," - ","GF, 5 hearts, 4 spades"]},
                                {id: "5.1.1.8", name:["3NT"," - ","choose of contract"]},
                                {id: "5.1.1.9", name:["4",<GiDiamonds />," - ","6+ hearts "]},
                                {id: "5.1.1.10", name:["4",<GiHearts />," - ","6+ spades "]},
                                
                            ]
                        },
                        {id: "5.1.2", name:["2",<GiHearts />," - ","4 hearts, may be 4 spades"], children:
                            [
                                {id: "5.1.2.1", name:["2",<GiSpades />," - ","slam interest, set heart as trump"]},
                                {id: "5.1.2.2", name:["2NT"," - ","invitational"]},
                                {id: "5.1.2.3", name:["3",<GiClubs />," - ","GF, 5+ clubs, little slam interest"]},
                                {id: "5.1.2.4", name:["3",<GiDiamonds />," - ","GF, 5+ diamonds, little slam interest"]},
                                {id: "5.1.2.5", name:["3",<GiHearts />," - ","invitational with 4+ hearts"]},
                                {id: "5.1.2.6", name:["3",<GiSpades />," - ","splinter"]},
                                {id: "5.1.2.7", name:["3NT"," - ","choose of contract"]},
                                {id: "5.1.2.8", name:["4",<GiClubs />," - ","splinter"]},
                                {id: "5.1.2.9", name:["4",<GiDiamonds />," - ","splinter"]},
                            ]
                        },
                        {id: "5.1.3", name:["2",<GiSpades />," - ","4 spades, no 4 hearts"], children:
                            [
                                {id: "5.1.3.1", name:["2NT"," - ","invitational"]},
                                {id: "5.1.3.2", name:["3",<GiClubs />," - ","GF, 5+ clubs, little slam interest"]},
                                {id: "5.1.3.3", name:["3",<GiDiamonds />," - ","GF, 5+ diamonds, little slam interest"]},
                                {id: "5.1.3.4", name:["3",<GiHearts />," - ","slam interest, set spades as trump"]},
                                {id: "5.1.3.5", name:["3",<GiSpades />," - ","invitational with 4+ hearts"]},
                                {id: "5.1.3.6", name:["3NT"," - ","choose of contract"]},
                                {id: "5.1.3.7", name:["4",<GiClubs />," - ","splinter"]},
                                {id: "5.1.3.8", name:["4",<GiDiamonds />," - ","splinter"]},
                                {id: "5.1.3.9", name:["4",<GiHearts />," - ","splinter"]},
                            ]
                        }, 
                    ]
                },
                {id: "5.2", name:["2",<GiDiamonds />," - ","5+ hearts"], children:
                    [
                        {id: "5.2.1", name:["2",<GiHearts />," - ","automatic"], children:
                            [
                                {id: "5.2.1.1", name:["2",<GiSpades />," - ","4 spades, invitational"]},
                                {id: "5.2.1.2", name:["2NT"," - ","invitational, no 6 hearts or 55 "]},
                                {id: "5.2.1.3", name:["3",<GiClubs />," - ","GF, 4+ clubs "]},
                                {id: "5.2.1.4", name:["3",<GiDiamonds />," - ","GF, 4+ diamonds "]},
                                {id: "5.2.1.5", name:["3",<GiHearts />," - ","invitational, 6+ hearts or 55 "]},
                                {id: "5.2.1.6", name:["3",<GiSpades />," - ","splinter "]},
                                {id: "5.2.1.7", name:["3NT"," - ","choose between 3NT and 4h"]},
                                {id: "5.2.1.8", name:["4",<GiClubs />," - ","splinter"]},
                                {id: "5.2.1.9", name:["4",<GiDiamonds />," - ","splinter"]},
                                {id: "5.2.1.10", name:["4",<GiHearts />," - ","6+ hearts, light slam invitation without shortness"]},
                                {id: "5.2.1.11", name:["4NT"," - ","5 hearts, slam invitation"]},
                            ]
                        },
                        {id: "5.2.3", name:["!!!2NT"," - ","3 good hearts, maximum"]},
                        {id: "5.2.4", name:["!!!3",<GiClubs />," - ","5 clubs, 4 hearts"]},
                        {id: "5.2.5", name:["!!!3",<GiDiamonds />," - ","5 diamonds, 4hearts"]},
                        {id: "5.2.6", name:["!!!3",<GiHearts />," - ","4+ hearts, maximum"]},
                    ]
                },
                {id: "5.3", name:["2",<GiHearts />," - ","5+ spades"], children:
                    [
                        {id: "5.3.1", name:["2",<GiSpades />," - ","automatic"], children:
                            [
                                {id: "5.3.1.1", name:["2NT"," - ","invitational, no 6 spades or 55 "]},
                                {id: "5.3.1.2", name:["3",<GiClubs />," - ","GF, 4+ clubs "]},
                                {id: "5.3.1.3", name:["3",<GiDiamonds />," - ","GF, 4+ diamonds "]},
                                {id: "5.3.1.4", name:["3",<GiHearts />," - ","GF, 5 hearts "]},
                                {id: "5.3.1.5", name:["3",<GiSpades />," - ","invitational, 5+ spades or 55 "]},
                                {id: "5.3.1.6", name:["3NT"," - ","choose of contract"]},
                                {id: "5.3.1.7", name:["4",<GiClubs />," - ","splinter"]},
                                {id: "5.3.1.8", name:["4",<GiDiamonds />," - ","splinter"]},
                                {id: "5.3.1.10", name:["4",<GiSpades />," - ","6+ spades, light slam invitation without shortness"]},
                                {id: "5.3.1.11", name:["4NT"," - ","5 hearts, slam invitation"]},
                            ]
                        },
                        {id: "5.3.3", name:["!!!2NT"," - ","3 good spades, maximum"]},
                        {id: "5.3.4", name:["!!!3",<GiClubs />," - ","5 clubs, 4 spades"]},
                        {id: "5.3.5", name:["!!!3",<GiDiamonds />," - ","5 diamonds, 4 spades"]},
                        {id: "5.3.6", name:["!!!3",<GiHearts />," - ","4+ spades, maximum"]},
                    ]
                },
                {id: "5.4", name:["2",<GiSpades />," - ","6+ clubs or invitational"], children:
                    [
                        {id: "5.4.1", name:["2NT"," - ","worse hand"], children:
                            [
                                {id: "5.4.1.1", name:["3",<GiClubs />," - ","SO"]},
                                {id: "5.4.1.2", name:["3",<GiDiamonds />," - ","shortness, 6+ clubs"]},
                                {id: "5.4.1.3", name:["3",<GiHearts />," - ","shortness, 6+ clubs"]},
                                {id: "5.4.1.4", name:["3",<GiSpades />," - ","shortness, 6+ clubs"]},
                                {id: "5.4.1.5", name:["3NT"," - ","light slam invitation, without shortness"]},
                                {id: "5.4.1.6", name:["4",<GiClubs />," - ","slam interest, without shortness"], children:
                                    [
                                        {id: "5.4.1.6.1", name:["4NT"," - ","bad hand, may be passed out"]},
                                        {id: "5.4.1.6.2", name: ["other"," - ","cuebid, better hand"]},
                                    ]
                                },
                            ]
                        },
                        {id: "5.4.2", name:["3",<GiClubs />," - ","better hand"], children: 
                            [
                                {id: "5.4.2.1", name:["3",<GiDiamonds />," - ","shortness, 6+ clubs"]},
                                {id: "5.4.2.2", name:["3",<GiHearts />," - ","shortness, 6+ clubs"]},
                                {id: "5.4.2.3", name:["3",<GiSpades />," - ","shortness, 6+ clubs"]},
                                {id: "5.4.2.4", name:["3NT"," - ","i've got only invitational hand"]},
                                {id: "5.4.2.5", name:["4",<GiClubs />," - ","slam interest, without shortness"], children:
                                    [
                                        {id: "5.4.2.5.1", name:["4NT"," - ","bad hand, may be passed out"]},
                                        {id: "5.4.2.5.2", name: ["other"," - ","cuebid, better hand"]},
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {id: "5.5", name:["2NT"," - ","6+ diamonds"], children:
                    {id: "5.5.1", name:["3",<GiClubs />," - ","better hand"], children:
                        [
                            {id: "5.5.1.1", name:["3",<GiDiamonds />," - ","SO"]},
                            {id: "5.5.1.2", name:["3",<GiHearts />," - ","6+ diamonds, shortness"]},
                            {id: "5.5.1.3", name:["3",<GiSpades />," - ","6+ diamonds, shortness"]},
                            {id: "5.5.1.4", name:["3NT"," - ","6+ diamonds, wo shortness, light slam invitational"]},
                            {id: "5.5.1.5", name:["4",<GiClubs />," - ","6+ diamonds, shortness"]}, 
                        ]
                    },
                },
                {id: "5.6", name:["3",<GiClubs />," - ","puppet stayman"]},
                {id: "5.7", name:["3",<GiDiamonds />," - ","invitational, 6+ diamonds"]},
                {id: "5.8", name:["3",<GiHearts />," - ","shortness, 45 in minors"]},
                {id: "5.9", name:["3",<GiSpades />," - ","shortness, 45 in minors"]},
                {id: "5.10", name:["3NT"," - ","choose of contract"]},
                {id: "5.11", name:["4",<GiClubs />," - ","both mayors, at least 65"]},
                {id: "5.12", name:["4",<GiClubs />," - ","6+ hearts, SO or strong hand we want to ask about keykards"]},
                {id: "5.13", name:["4",<GiHearts />," - ","6+ spades, SO or strong hand we want to ask about keykards"]},
            ]
        },
        {id: 6, name: ["2",<GiClubs />," - ","10-14HCP, 6+ clubs or 5+clubs and 4M" ], children:
            [
                {id: "6.1", name: ["2",<GiDiamonds />," - ","relay"], children:
                    [
                        {id: "6.1.1", name: ["2",<GiHearts />," - ","4 hearts"], children:
                            [
                                {id: "6.1.1.1", name: ["2",<GiSpades />," - ","relay"], children:
                                    [
                                        {id: "6.1.1.1.1", name: ["2NT"," - ","2425, honours in short colours"]},
                                        {id: "6.1.1.1.2", name: ["3",<GiClubs />," - ","6 clubs"]},
                                        {id: "6.1.1.1.3", name: ["3",<GiDiamonds />," - ","3 diamonds"]},
                                        {id: "6.1.1.1.4", name: ["3",<GiHearts />," - ","2425 honours in long colours"]},
                                        {id: "6.1.1.1.5", name: ["3",<GiSpades />," - ","3 spades"]},
                                        {id: "6.1.1.1.6", name: ["after response"], children:
                                            [
                                                {id: "6.1.1.1.6.1", name: ["4",<GiClubs />," - ","set club as trump"]},
                                                {id: "6.1.1.1.6.2", name: ["other"," - ","set spade as trump"]}, 
                                            ]},
                                    ]
                                },
                                {id: "6.1.1.2", name: ["2NT"," - ","invitational"]},
                                {id: "6.1.1.3", name: ["3",<GiClubs />," - ","generally a SO"]},
                                {id: "6.1.1.4", name: ["3",<GiDiamonds />," - ","GF, 5+ diamonds"]},
                                {id: "6.1.1.5", name: ["3",<GiHearts />," - ","invitational, 4 + hearts"]},
                                {id: "6.1.1.6", name: ["3",<GiSpades />," - ","GF, 6+ spades"]},
                            ]
                        },
                        {id: "6.1.2", name: ["2",<GiSpades />," - ","4 spades"], children: 
                            [
                                {id: "6.1.2.1", name: ["2NT"," - ","relay"], children:
                                    [
                                        {id: "6.1.2.1.1", name: ["3",<GiClubs />," - ","6 clubs"]},
                                        {id: "6.1.2.1.2", name: ["3",<GiDiamonds />," - ","3 diamonds"]},
                                        {id: "6.1.2.1.3", name: ["3",<GiHearts />," - ","4225 honours in long colours"]},
                                        {id: "6.1.2.1.4", name: ["3",<GiSpades />," - ","3 spades"]},
                                        {id: "6.1.2.1.5", name: ["3NT"," - ","4225 honours in short colours"]},
                                        {id: "6.1.2.1.6", name: ["after response"], children:
                                            [
                                                {id: "6.1.2.1.6.1", name: ["4",<GiClubs />," - ","set club as trump"]},
                                                {id: "6.1.2.1.6.2", name: ["other"," - ","set spade as trump"]}, 
                                            ]},
                                    ]
                                },
                                {id: "6.1.2.2", name: ["2NT"," - ","invitational"]},
                                {id: "6.1.2.3", name: ["3",<GiClubs />," - ","generally a SO"]},
                                {id: "6.1.2.4", name: ["3",<GiDiamonds />," - ","GF, 5+ diamonds"]},
                                {id: "6.1.2.5", name: ["3",<GiHearts />," - ","GF, 6+ hearts"]},
                                {id: "6.1.2.6", name: ["3",<GiSpades />," - ","invitational, 4+ spades"]},
                            ]
                        },
                        {id: "6.1.3", name: ["2NT"," - ","6 clubs, better hand"], children:
                            [
                                {id: "6.1.3.1", name: ["3",<GiClubs />," - ","NF, generally SO"]},
                                {id: "6.1.3.2", name: ["???3",<GiDiamonds />," - ","ask about minor triplet"]}, 
                            ]
                        },
                        {id: "6.1.4", name: ["3",<GiClubs />," - ","6 clubs, minimum"], children:
                            [
                                {id: "6.1.4.1", name: ["???3",<GiDiamonds />," - ","ask about minor triplet"]},
                            ] 
                        },
                        {id: "6.1.5", name: ["3",<GiDiamonds />," - ","6 clubs, 4 diamonds, maximum"]},
                        {id: "6.1.6", name: ["3",<GiHearts />," - ","6 clubs, 4 hearts, maximum"]},
                        {id: "6.1.7", name: ["3",<GiSpades />," - ","6 clubs, 4 spades, maximum"]},
                        {id: "6.1.8", name: ["3NT"," - ","AKQxxxx in clubs"]},
                    ]
                },
                {id: "6.2", name: ["2",<GiHearts />," - ","5+ hearts, NF"]},
                {id: "6.3", name: ["2",<GiSpades />," - ","5+ spades, NF"]},
                {id: "6.4", name: ["2NT"," - ","weak with club support or 55 GF"]},
                {id: "6.5", name: ["3",<GiClubs />," - ","invitational with club support"]},
                {id: "6.6", name: ["3",<GiDiamonds />," - ","GF, 6+ diamond"]},
                {id: "6.7", name: ["3",<GiHearts />," - ","6+ good hearts, invitational"]},
                {id: "6.8", name: ["3",<GiSpades />," - ","6+ good spades, invitational"]},
                {id: "6.9", name: ["3NT"," - ","choose of contract"]},
                {id: "6.10", name: ["4",<GiClubs />," - ","preemtive"]},
                {id: "6.11", name: ["4",<GiDiamonds />," - ","splinter"]},
                {id: "6.12", name: ["4",<GiHearts />," - ","SO"]},
                {id: "6.13", name: ["4",<GiSpades />," - ","SO"]},
            ]
        },
        {id: 7, name:["2",<GiDiamonds />," - ","6 card in major, preemptive"], children:
            [
                {id: "7.1", name:["2",<GiHearts />," - ","pass or correct (or so on hearts)"]},
                {id: "7.2", name:["2",<GiSpades />," - ","pass with spades (or so on spades)"]},
                {id: "7.3", name:["2NT"," - ","GF relay"], children:
                    [
                        {id: "7.3.1", name:["3",<GiClubs />," - ","minimum hand"], children:
                            [
                                {id: "7.3.1.1", name:["3",<GiDiamonds />," - ","show your color in reverse"], children:
                                    [
                                        {id: "7.3.1.1.1", name:["3",<GiHearts />," - ","spades"]},
                                        {id: "7.3.1.1.2", name:["3",<GiSpades />," - ","hearts"]},
                                    ]
                                },
                            ]
                        },
                        {id: "7.3.2", name:["3",<GiDiamonds />," - ","better hand with hearts"], children:
                            [
                                {id: "7.3.2.1", name:["3",<GiHearts />," - ","set hearts as trump, show shortness"]}, 
                            ]
                        },
                        {id: "7.3.3", name:["3",<GiHearts />," - ","better hand with spades"], children:
                            [
                                {id: "7.3.3.1", name:["3",<GiSpades />," - ","set spades as trump, show shortness"]},
                            ]
                        },
                    ]
                },
                {id: "7.4", name:["3",<GiClubs />," - ","GF on own suit"]},
                {id: "7.5", name:["3",<GiDiamonds />," - ","invitational with support in both major suits"]},
                {id: "7.6", name:["3",<GiHearts />," - ","preemptive with support in both major suits"]},
                {id: "7.7", name:["3",<GiSpades />," - ","preemptive with spade, bid 4 hearts if you have"]},
                {id: "7.8", name:["3NT"," - ","choose of contract"]},
                {id: "7.9", name:["4",<GiClubs />," - ","show your color by transfer"]},
                {id: "7.10", name:["4",<GiDiamonds />," - ","show your"]},
                {id: "7.11", name:["4",<GiHearts />," - ","SO"]},
                {id: "7.12", name:["4",<GiSpades />," - ","SO"]},
            ]
        },
        {id: 8, name: ["2",<GiHearts />," - ","5 hearts, 5+ in minor (4+ non vurnerable)" ], children:
            [
                {id: "8.1", name: ["2",<GiSpades />," - ","6+ spades, generally SO" ]},
                {id: "8.2", name: ["2NT"," - ","GF relay"], children:
                    [
                        {id: "8.2.1", name: ["3",<GiClubs />," - ","5+ clubs minimum, or only 4 clubs" ]},
                        {id: "8.2.2", name: ["3",<GiDiamonds />," - ","5+ diamonds minimum, or only 4 diamonds" ]},
                        {id: "8.2.3", name: ["3",<GiHearts />," - ","5+ clubs maximum"]},
                        {id: "8.2.4", name: ["3",<GiSpades />," - ","5+ diamonds maximum"]},
                    ]
                },
                {id: "8.3", name: ["3",<GiClubs />," - ","pass or correct"]},
                {id: "8.4", name: ["3",<GiDiamonds />," - ","invitational with heart support"]},
                {id: "8.5", name: ["3",<GiHearts />," - ","preemptive with heart support"]},
                {id: "8.6", name: ["3",<GiSpades />," - ","GF, 6+ spades"]},
                {id: "8.7", name: ["3NT"," - ","choose of contract"]},
                {id: "8.8", name: ["4",<GiClubs />," - ","pass or correct"]},
                {id: "8.9", name: ["!!4NT"," - ","show your minor color"]},
                {id: "8.10", name: ["!!!5",<GiClubs />," - ","choose of contract"]},
            ]
        },
        {id: 9, name: ["2",<GiSpades />," - ","5 spades, 5+ in minor (4+ non vurnerable)" ], children:
            [
                {id: "9.1", name: ["2NT"," - ","GF relay"], children:
                    [
                        {id: "9.1.1", name: ["3",<GiClubs />," - ","5+ clubs minimum, or only 4 clubs" ]},
                        {id: "9.1.2", name: ["3",<GiDiamonds />," - ","5+ diamonds minimum, or only 4 diamonds" ]},
                        {id: "9.1.3", name: ["3",<GiHearts />," - ","5+ clubs maximum"]},
                        {id: "9.1.4", name: ["3",<GiSpades />," - ","5+ diamonds maximum"]},
                    ]
                },
                {id: "9.2", name: ["3",<GiClubs />," - ","pass or correct"]},
                {id: "9.3", name: ["3",<GiDiamonds />," - ","invitational with spade support"]},
                {id: "9.4", name: ["3",<GiHearts />," - ","GF, 6+ spades,"]},
                {id: "9.5", name: ["3",<GiSpades />," - ","preemptive with heart support"]},
                {id: "9.6", name: ["3NT"," - ","choose of contract"]},
                {id: "9.7", name: ["4",<GiClubs />," - ","pass or correct"]},
                {id: "9.8", name: ["!!4NT"," - ","show your minor color"]},
                {id: "9.9", name: ["!!!5",<GiClubs />," - ","choose of contract"]},
            ]
        },
        {id: 10, name: ["2NT"," - ","21-22 balanced"], children:
            [
                {id: "10.1", name: ["3",<GiClubs />," - ","puppet stayman"]},
                {id: "10.2", name: ["3",<GiDiamonds />," - ","5+ hearts"]},
                {id: "10.3", name: ["3",<GiHearts />," - ","5+ spades"]},
                {id: "10.4", name: ["3",<GiSpades />," - ","minors"]},
                {id: "10.5", name: ["3NT"," - ","5 spades, 4 hearts"]},
                {id: "10.6", name: ["4",<GiClubs />," - ","6+ diamonds"]},
                {id: "10.7", name: ["4",<GiDiamonds />," - ","6+ hearts"]},
                {id: "10.8", name: ["4",<GiHearts />," - ","6+ spades"]},
                {id: "10.9", name: ["4",<GiSpades />," - ","6+ clubs"]},
                {id: "10.10", name: ["4NT"," - ","slam invitation"]},
            ]
        },
        {id: 11, name: ["4rd hand"], children: 
            [
                {id: "11.1", name: ["1",<GiClubs className="icon-with-space"/>," to 2",<GiClubs className="icon-with-space"/>,"- without changes"]},
                {id: "11.2", name: ["2",<GiDiamonds className="icon-with-space"/>," to 2",<GiSpades className="icon-with-space"/>,"- 6 card suit, 13-15 HCP"]},
            ]
        }
    ]
};

 const data = flattenTree(system);

function ContolledExpandedNode() {
    const [expandedIds, setExpandedIds]  = useState();

    const onKeyDown = (e) => {
        if (e.key === 'Enter'){
            getAndSetIds();
        }
    }

    const getAndSetIds = () => {
        setExpandedIds(
            document
                .querySelector('#txtIdsToExpand')
                .value.split(",")
                .filter(val => !!val.trim())
                .map((x)=>{
                    if (isNaN(parseInt(x.trim()))){
                        return x;
                    }
                    return parseInt(x.trim());
                })
        );
    };

    const expandAll = () => {
        const allNodeIds = flattenTree(system).map(node => node.id);
        setExpandedIdsA(allNodeIds);
    }

    return (
        <div>
            <div>
                <Button onClick={()=>expandAll()}>Expand all</Button>
                <Button onClick={() => setExpandedIdsA([])}> Collapse all</Button>
            </div>
            <div>
                <button onClick={()=>setExpandedIds([])}>
                    Clear expanded nodes
                </button>
            </div>
            <div className="checkbox">
                <TreeView
                    data = {data}
                    aria-label = "Controlled expanded node tree"
                    expandedIds={expandedIds}
                    defaultExpandedIds={[]}
                    nodeRenderer={({
                        element,
                        isBranch,
                        isExpanded,
                        isDisabled,
                        getNodeProps,
                        level,
                        handleExpand,
                    })=>{
                        return (
                            <div
                                {...getNodeProps({onClick: handleExpand})}
                                style = {{
                                    marginLeft: 40*(level-1),
                                    opacity: isDisabled ? 0.5 : 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}
                            >
                                {isBranch && <ArrowIcon isOpen = {isExpanded}/>}
                                <span style={{display: 'flex', alignItems: 'center'}} >
                                    {element.name}
                                    </span>
                            </div>
                        );
                    }}
                    />
            </div>
        </div>
    );

}

const ArrowIcon = ({isOpen, className}) => {
    const baseClass = "arrow";
    const classes = cx(
        baseClass,
        {[`${baseClass}--closed`]: !isOpen},
        {[`${baseClass}--open`]: isOpen},
        className
    );
    return <IoMdArrowDropright className={classes} />;
}

export default ContolledExpandedNode